import { validateTidalLicense } from "../../base/index.js";
import { camelCase } from "./camelCase.js";
import { upperCase } from "./utils/upperCase.js";
function pascalCase(source) {
  return camelCase(source).replace(/^[a-z]/, upperCase);
}
validateTidalLicense();
export {
  pascalCase
};
//# sourceMappingURL=pascalCase.js.map
